<template>
  <div class="pxzt">
    <hljHeader :backColor="`#AC0209`"></hljHeader>
    <div class="pxzt-banner">

    </div>
    <div class="pxzt-content">

      <div class="xjp-content">
        <div class="xjp-title">习近平新时代中国特色社会主义思想</div>
        <div class="xjp-main">
          <swiper :options="xjpSwiperOption" v-if="xjpList.length">
            <swiper-slide v-for="item in xjpList" :key="item.id" :data-id="item.id">
              <div :data-id="item.id" :style="`background-image:url(${item.photo});`"></div>
            </swiper-slide>
          </swiper>
          <div class="swiper-pagination xjp"></div>
        </div>
      </div>
      <div class="dxjy-content">
        <div class="dxjy-title">党性教育</div>
        <div class="dxjy-main">
          <div class="dxjy-item" v-for="item in dxjyList" :key="item.id" @click="jumpDetail(item)">
            <div :style="`background-image:url(${item.photo});`"></div>
          </div>
          <div class="empty-item"></div>
          <div class="empty-item"></div>
        </div>
      </div>
      <div class="jyqg-bg">
        <div class="jyqg-content">
          <div class="jyqg-title">教育强国建设与教育家精神</div>
          <div class="jyqg-main">
            <div class="jyqg-item" v-for="item in jyqgList" :key="item.id" @click="jumpDetail(item)">
              <div :style="`background-image:url(${item.photo});`"></div>
            </div>
            <div class="empty-item"></div>
            <div class="empty-item"></div>
          </div>
        </div>
        <div class="sdsf-content">
          <div class="sdsf-title">师德师风建设</div>
          <div class="sdsf-main">
            <div class="sdsf-item" v-for="item in sdsfList" :key="item.id" @click="jumpDetail(item)">
              <div class="item-img">
                <div :style="`background-image:url(${item.photo});`"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="dxxyts-content">
        <div class="dxxyts-title">党性修养提升</div>
        <div class="dxxyts-main">
          <div class="dxxyts-item" v-for="item in dxxyList" :key="item.id" @click="jumpDetail(item)">
            <div :style="`background-image:url(${item.photo});`"></div>
          </div>
          <div class="empty-item"></div>
          <div class="empty-item"></div>
        </div>
      </div>

    </div>
    <hljFooter></hljFooter>
  </div>
</template>

<script>
import utils from "../../../../config/utils"
import hljHeader from "../../../../components/Custom/hlj/hlj_header.vue"
import hljFooter from "../../../../components/Custom/hlj/hlj-footer.vue"
import services from '@/config/services'
export default {
  data() {
    let that = this
    return {
      school_code: utils.getUrlSchoolCode(window.location.pathname) || localStorage.getItem("schoolCode"),
      utils,
      xjpSwiperOption: {
        autoplay: {
          delay: 8000,
          disableOnInteraction: false
        },
        effect: "coverflow",
        loop: true,
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: "auto",
        coverflowEffect: {
          rotate: 0,
          stretch: 300,
          depth: 280,
          modifier: 1,
          slideShadows: false,
        },
        preventClicksPropagation: false,
        pagination: {
          el: `.swiper-pagination.xjp`,
        },
        on: {
          click: (e) => {
            let id = e.target.getAttribute("data-id")
            window.open(`/center/${that.school_code}/custom/hljdypx/hljDetail?id=${id}&key=new`)
          },

        },
      },
      xjpList: [],
      dxjyList: [],
      jyqgList: [],
      sdsfList: [],
      dxxyList: [],

    }
  },
  components: {
    hljHeader,
    hljFooter
  },
  methods: {
    async getListData() {
      await services.getCourseList({ page: 1, size: 10, category_id: "464", school_code: this.school_code }).then(res => {
        this.xjpList = res.data.items
      })
      await services.getCourseList({ page: 1, size: 10, category_id: "465", school_code: this.school_code }).then(res => {
        this.dxjyList = res.data.items
      })
      await services.getCourseList({ page: 1, size: 10, category_id: "466", school_code: this.school_code }).then(res => {
        this.jyqgList = res.data.items
      })
      await services.getCourseList({ page: 1, size: 10, category_id: "467", school_code: this.school_code }).then(res => {
        this.sdsfList = res.data.items
      })
      await services.getCourseList({ page: 1, size: 10, category_id: "468", school_code: this.school_code }).then(res => {
        this.dxxyList = res.data.items
      })
    },
    jumpDetail(item) {
      if (item) {
        window.open(`/center/${this.school_code}/custom/hljdypx/hljDetail?id=${item.id}&key=jjfz`, "_blank")
      }
    },

  },
  created() {
    this.utils.setFonts()
    this.getListData()
  },
  mounted() {
    window.onresize = () => {
      this.utils.setFonts()
    }
  }

}
</script>
<style lang="less" scoped>
.pxzt {
  .pxzt-banner {
    height: 4.8rem;
    background-image: url("../../../../assets/custom/hlj/pxzt/pxtz-banner.png");
    width: 100%;
    background-size: cover;
    background-position: center;
  }
  .pxzt-content {
    background-color: #fff;
    width: 100%;
    padding-top: 0.5rem;
    .xjp-content {
      width: 12rem;
      margin: 0 auto 0;
      .xjp-title {
        font-weight: bold;
        font-size: 0.32rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        line-height: 1.1;
        &::before,
        &::after {
          content: "";
          width: 2.57rem;
          height: 0.18rem;
          display: block;
          background-image: url("../../../../assets/custom/hlj/pxzt/xjp-title.png");
          background-size: cover;
          background-position: center;
        }
        color: #c31117;
      }
      .xjp-main {
        margin-top: 0.36rem;
        height: 4.6rem;
        position: relative;
        .swiper-container {
          position: relative;
          .swiper-wrapper {
            .swiper-slide {
              width: 7.2rem;
              height: 4.05rem;
              background-color: #c31117;
              overflow: hidden;
              cursor: pointer;
              &:hover {
                div {
                  transform: scale(1.1);
                }
              }
              div {
                transition: all 0.3s;
                width: 100%;
                height: 100%;
                // background-image: url("../../../../assets/");
                background-size: cover;
                background-position: center;
                background-color: #c31117;
              }
            }
          }
        }
        /deep/ .swiper-pagination {
          &.xjp {
            display: flex;
            justify-content: center;
            margin-top: 0.36rem;
            .swiper-pagination-bullet {
              display: block;
              margin: 0 0.07rem;
              width: 0.1rem;
              height: 0.1rem;
              background: #cdb29f;
              border-radius: 50%;
              &.swiper-pagination-bullet-active {
                background: #dd3639;
              }
            }
          }
        }
      }
    }
    .dxjy-content {
      width: 12rem;
      margin: 0.4rem auto 0;
      padding-bottom: 0.47rem;
      .dxjy-title {
        font-weight: bold;
        font-size: 0.32rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        line-height: 1.1;
        &::before,
        &::after {
          content: "";
          width: 4.67rem;
          height: 0.17rem;
          display: block;
          background-image: url("../../../../assets/custom/hlj/jjfz/rdbb-title.png");
          background-size: cover;
          background-position: center;
        }
        color: #c31117;
      }
      .dxjy-main {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin: 0.35rem auto 0;
        .dxjy-item {
          width: 2.8rem;
          height: 1.57rem;
          overflow: hidden;
          cursor: pointer;

          &:hover {
            div {
              transform: scale(1.1);
            }
          }
          div {
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            transition: all 0.3s;
          }
        }
        .empty-item {
          width: 2.8rem;
        }
      }
    }
    .jyqg-bg {
      background: #fffcf0;
      padding-bottom: 0.36rem;
      .jyqg-content {
        width: 12rem;
        margin: 0 auto 0;
        padding-top: 0.48rem;
        padding-bottom: 0.47rem;
        .jyqg-title {
          font-weight: bold;
          font-size: 0.32rem;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          line-height: 1.1;
          &::before,
          &::after {
            content: "";
            width: 3.27rem;
            height: 0.17rem;
            display: block;
            background-image: url("../../../../assets/custom/hlj/pxzt/jyqg-title.png");
            background-size: cover;
            background-position: center;
          }
          color: #c31117;
        }
        .jyqg-main {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          margin: 0.35rem auto 0;
          .jyqg-item {
            width: 3.8rem;
            height: 2.14rem;
            overflow: hidden;
            margin-bottom: 0.36rem;
            cursor: pointer;

            &:hover {
              div {
                transform: scale(1.1);
              }
            }
            div {
              width: 100%;
              height: 100%;
              background-size: cover;
              background-position: center;
              transition: all 0.3s;
            }
          }
          .empty-item {
            width: 3.8rem;
          }
        }
      }
      .sdsf-content {
        width: 12rem;
        margin: 0.46rem auto 0;
        .sdsf-title {
          font-weight: bold;
          font-size: 0.32rem;
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          line-height: 1.1;
          &::before,
          &::after {
            content: "";
            width: 4.19rem;
            height: 0.17rem;
            display: block;
            background-image: url("../../../../assets/custom/hlj/jjfz/xsx-title.png");
            background-size: cover;
            background-position: center;
          }
          color: #c31117;
        }
        .sdsf-main {
          display: flex;
          justify-content: space-between;
          margin-top: 0.36rem;
          .sdsf-item {
            width: 5.8rem;
            height: 3.38rem;
            background: #ac0209;
            padding: 0.12rem;
            cursor: pointer;
            cursor: pointer;

            .item-img {
              width: 100%;
              height: 100%;
              overflow: hidden;
              &:hover {
                div {
                  transform: scale(1.1);
                }
              }
              div {
                transition: all 0.3s;
                width: 100%;
                height: 100%;
                // background-image: url("../../../../assets/");
                background-size: cover;
                background-position: center;
                background-color: #c31117;
              }
            }
          }
        }
      }
    }
    .dxxyts-content {
      width: 12rem;
      margin: 0 auto 0;
      padding-top: 0.48rem;
      .dxxyts-title {
        font-weight: bold;
        font-size: 0.32rem;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        line-height: 1.1;
        &::before,
        &::after {
          content: "";
          width: 3.27rem;
          height: 0.17rem;
          display: block;
          background-image: url("../../../../assets/custom/hlj/pxzt/jyqg-title.png");
          background-size: cover;
          background-position: center;
        }
        color: #c31117;
      }
      .dxxyts-main {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        margin: 0.35rem auto 0;
        .dxxyts-item {
          width: 3.8rem;
          height: 2.14rem;
          overflow: hidden;
          margin-bottom: 0.36rem;
          cursor: pointer;

          &:hover {
            div {
              transform: scale(1.1);
            }
          }
          div {
            width: 100%;
            height: 100%;
            background-size: cover;
            background-position: center;
            transition: all 0.3s;
          }
        }
        .empty-item {
          width: 3.8rem;
        }
      }
    }
  }
}
</style>